import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const ModalComedor = ({
  show,
  onHide,
  onSave,
  comedor,
}) => {
  const [nombre, setNombre] = useState("");
  const [activo, setActivo] = useState(true);
  const [error, setError] = useState("");
  
  // Obtener proyecto de la sesión
  const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');

  useEffect(() => {
    if (comedor) {
      setNombre(comedor.nombre || "");
      setActivo(comedor.activo !== undefined ? comedor.activo : true);
    } else {
      setNombre("");
      setActivo(true);
    }
    setError("");
  }, [comedor, show]);

  const handleSave = () => {
    if (!nombre.trim()) {
      setError("El nombre del comedor es obligatorio");
      return;
    }

    if (!selectedProject || !selectedProject.id) {
      setError("No se ha seleccionado un proyecto en la sesión");
      return;
    }

    const comedorData = {
      nombre: nombre.trim(),
      activo: activo,
      id_proyecto: parseInt(selectedProject.id),
    };

    onSave(comedorData);
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {comedor ? "Editar Comedor" : "Nuevo Comedor"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <div className="alert alert-danger">{error}</div>}
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Proyecto</Form.Label>
            <Form.Control
              type="text"
              value={selectedProject?.proyecto_nombre || selectedProject?.nombre || 'No hay proyecto seleccionado'}
              readOnly
              className="bg-light"
              style={{ fontWeight: 'bold', color: '#495057' }}
            />
            <Form.Text className="text-muted">
              Este comedor será creado para el proyecto actual de la sesión
            </Form.Text>
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label>Nombre del Comedor *</Form.Label>
            <Form.Control
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              placeholder="Ingrese el nombre del comedor"
              required
            />
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              id="activo-checkbox"
              label="Activo"
              checked={activo}
              onChange={(e) => setActivo(e.target.checked)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleSave}>
          {comedor ? "Actualizar" : "Crear"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalComedor;
